export const BroadcastChannelMessageType = {
  ConnectionResult: 'connection-result',
  ResultReceived: 'result-received'
};
export const handleConnectionStatusUpdate = () => {
  return new Promise((resolve, reject) => {
    const channel = new BroadcastChannel('accept-payments-provider-connection-status');
    channel.onmessage = e => {
      const {
        type,
        errorCode
      } = e.data;
      const isSuccess = !errorCode || errorCode === 0 || errorCode === '0';
      if (isSuccess && type === BroadcastChannelMessageType.ConnectionResult) {
        channel.postMessage({
          type: BroadcastChannelMessageType.ResultReceived
        });
        channel.close();
        resolve();
      } else {
        reject(new Error(String(errorCode)));
      }
    };
  });
};
//# sourceMappingURL=handleConnectionStatusUpdate.js.map